<template>
  <div class="routes">
    <el-row v-if="isMobile">
      <el-col :span="24">
        <h3 style="margin-bottom: 0 !important">
          Организации в вашем аккаунте:
        </h3>
        <span style="color: grey; font-size: 13px">
          указанные при регистрации аккаунта
        </span>
        <div
          v-for="(org, i) in organizations"
          :key="org.id"
          style="padding: 0 0px"
        >
          <div
            style="padding-top: 10px; border: 1px solid #efefef; margin: 10px 0"
          >
            <table width="100%">
              <tr>
                <td width="50" valign="top">
                  <img
                    v-if="org.id === current.id"
                    src="@/assets/img/current.svg"
                  />
                </td>
                <td>
                  <b>{{ org.organization.short_name }}</b>
                  <p style="margin-top: 5px !important">
                    {{ org.organization.inn }}
                  </p>
                  <el-link
                    icon="el-icon-edit"
                    type="primary"
                    @click="editOrg(org)"
                  >
                    Изменить данные компании
                  </el-link>
                </td>
              </tr>
            </table>
            <p />
          </div>

          <p>
            <el-button
              v-if="organizations.length > 1"
              class="make_cur_org"
              type="primary"
              @click="chooseCurrent(i)"
            >
              Сделать текущей
            </el-button>
          </p>
          <div class="c-dialog-head">
            <!--<a href="" target="_blank" class="c-dialog-head__link"><el-button class="c-dialog-head__btn" type="success" icon="el-icon-copy-document" circle title="Скопировать ссылку на профиль"></el-button></a>-->
            <a href="#" target="_blank" class="c-dialog-head__link">
              <el-button v-if="false" class="make_cur_org">
                Скопировать ссылку на профиль
              </el-button>
            </a>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row v-if="!isMobile" :gutter="24" class="routes-row">
      <el-col :span="18">
        <div class="routes_chekers">
          <el-row :gutter="24" class="routes-row">
            <el-col :span="8">Наименование</el-col>
            <el-col :span="4">ИНН</el-col>
            <el-col :span="4">Текущая компания</el-col>
            <el-col :span="4" />
            <el-col :span="4">
              <el-button type="text" class="add_org" @click="handleModal">
                Добавить компанию
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div v-for="(org, i) in organizations" :key="org.id" class="route_tble">
          <el-row :gutter="24" style="display: flex; align-items: center">
            <el-col :span="8">
              <div class="doc-list_col_centered">
                {{ org.organization.short_name }}
              </div>
            </el-col>
            <el-col :span="4">
              <div class="doc-list_col_centered">
                {{ org.organization.inn }}
              </div>
            </el-col>
            <el-col :span="4">
              <div v-if="org.id === current.id" class="doc-list_col_centered">
                <img src="@/assets/img/current.svg" />
              </div>
            </el-col>
            <el-col :span="4">
              <div v-if="org.id !== current.id" class="doc-list_col_centered">
                <el-button
                  type="text"
                  class="make_cur_org"
                  @click="chooseCurrent(i)"
                >
                  Сделать текущей
                </el-button>
              </div>
            </el-col>
            <el-col :span="4">
              <div
                class="c-dialog-head doc-list_col_centered"
                style="padding: 0 20px"
              >
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  circle
                  @click="editOrg(org)"
                />
                <a
                  href="#"
                  target="_blank"
                  class="c-dialog-head__link"
                  @click.prevent="copyOrganizationCardLink(org.organization_id)"
                >
                  <el-button
                    class="c-dialog-head__btn"
                    size="small"
                    type="success"
                    icon="el-icon-copy-document"
                    circle
                    title="Скопировать ссылку на профиль"
                  />
                </a>
                <!--<a href="" target="_blank" class="c-dialog-head__link"><el-button class="c-dialog-head__btn" type="success" icon="el-icon-copy-document" title="Скопировать ссылку на профиль">Скопировать ссылку на профиль</el-button></a>-->
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      v-if="!isMobile"
      title="Добавление организации"
      :visible="visible"
      :width="widthDialog"
      :close-on-click-modal="false"
      :before-close="handleModal"
    >
      <AddOrganization :user-id="userId" :close="handleModal" />
    </el-dialog>
  </div>
</template>

<script>
import { SET_CURRENT } from '@/store/actions/userprofile'
import AddOrganization from '@/components/Forms/AddOrganization'

export default {
  name: 'Organizations',
  components: {
    AddOrganization,
  },
  props: {
    current: {
      type: Object,
      default: () => {},
    },
    organizations: {
      type: Array,
      default: () => [],
    },
    userId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
      editVisible: false,
      editOrganization: null,
    }
  },
  beforeDestroy() {
    this.$notify.closeAll()
  },
  methods: {
    async copyOrganizationCardLink() {
      let message = 'Ссылка на организацию скопирована'

      try {
        let {
          data: { code },
        } = {
          data: {
            code: '1569424530_5d8b8492c5148',
            share_link: '.../api/v1/sharings/1569424530_5d8b8492c5148',
          },
        }

        if (!code) {
          throw new Error('не верный ответ сервера')
        }
        const { host, protocol } = window.location
        const componentName = 'company-card'
        const link = `${protocol}//${host}/${componentName}/${code}`

        this.copyShareLink(link)
      } catch (e) {
        message = 'Ошибка копирования ссылки!'
      }
      this.$notify({
        message,
        duration: 0,
      })
    },
    copyShareLink(link) {
      let tempElement = document.createElement('INPUT')

      tempElement.value = link
      document.body.appendChild(tempElement)
      tempElement.select()
      document.execCommand('copy')
      document.body.removeChild(tempElement)
    },
    chooseCurrent(i) {
      this.$store.commit(`userProfile/${SET_CURRENT}`, i)
    },
    handleModal() {
      this.visible = !this.visible
    },
    editOrg(org) {
      this.$router.push({
        path: '/organization-edit?id=' + org.id,
        params: {
          id: org.id,
        },
      })
      this.editOrganization = org
    },
    closeModal() {
      this.editOrganization = null
    },
  },
}
</script>

<style lang="sass">
.user_profile_form
  .routes
    .routes_chekers
      margin-top: 25px;
      .routes-row
        display: flex;
        align-items: center;
        div.el-col
          font-size: 12px;
          line-height: 14px;
          text-align: center;
          color: #656565;
    .route_tble
      position: relative;
      border-radius: 2px;
      background: #fff;
      box-sizing: border-box;
      font-size: 14px;
      line-height: 17px;
      font-weight: bold;
      margin-bottom: 15px;
      height: 65px;
      display: grid;
      text-align: center;
      .doc-list_col_centered
        .doc-phone
          border: none;
          font-weight: bold;
          -ms-flex-align: center;
          text-align: center;
          width: 100%;
          outline: none;
          cursor: auto;
    .add_org
      text-decoration: underline;
      font-size: 18px;
      margin-left: -10px;
    .make_cur_org
      text-decoration: underline;
      color: #2ECC71;
</style>
